var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { style: _vm.s.container }, [
    _c("div", { style: _vm.s.wrapper }, [
      _c("div", { style: _vm.s.title }, [
        _vm._v(_vm._s(_vm.Title)),
        _c("span", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.ShowClose,
              expression: "ShowClose"
            }
          ],
          style: _vm.s.close,
          on: { click: _vm.close }
        })
      ]),
      _c("div", { staticClass: "head" }, [
        _vm._v(
          _vm._s(
            !_vm.isConnected
              ? _vm.$t("assets.ledger.connect.selectConnectType")
              : _vm.$t("assets.ledger.connect.tips")
          )
        )
      ]),
      _c("div", { style: _vm.s.body }, [
        _vm.isConnected
          ? _c("div", { staticClass: "__row" }, [
              _vm.addressList && _vm.addressList.length
                ? _c("table", { staticClass: "hw_table" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th"),
                        _c("th", [
                          _vm._v(
                            _vm._s(_vm.$t("assets.ledger.addressSelect.index"))
                          )
                        ]),
                        _c("th", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("assets.ledger.addressSelect.address")
                            )
                          )
                        ]),
                        _c("th", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("assets.ledger.addressSelect.balance")
                            )
                          )
                        ]),
                        _c("th", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("assets.ledger.addressSelect.unreceived")
                            )
                          )
                        ])
                      ])
                    ]),
                    _c(
                      "tbody",
                      _vm._l(_vm.addressList, function(address) {
                        return _c("tr", { key: address.index }, [
                          _c(
                            "th",
                            [
                              _c("checkbox", {
                                on: {
                                  input: function($event) {
                                    return _vm.onSelect(address, $event)
                                  }
                                },
                                model: {
                                  value: address.isChecked,
                                  callback: function($$v) {
                                    _vm.$set(address, "isChecked", $$v)
                                  },
                                  expression: "address.isChecked"
                                }
                              })
                            ],
                            1
                          ),
                          _c("th", [_vm._v(_vm._s(address.index))]),
                          _c("th", [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    "https://vitescan.io/address/" +
                                    address.address,
                                  target: "_blank"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm._f("shortAddr")(address.address))
                                )
                              ]
                            ),
                            !address.blockCount &&
                            address.blockCount !== undefined
                              ? _c("span", { staticClass: "code_small_btn" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "assets.ledger.addressSelect.unUsedAccount"
                                      )
                                    )
                                  )
                                ])
                              : _vm._e()
                          ]),
                          _c("th", [
                            _vm._v(
                              _vm._s(_vm._f("toBasic")(address.balance, 18))
                            )
                          ]),
                          _c("th", [
                            _vm._v(
                              _vm._s(_vm._f("toBasic")(address.unreceived, 18))
                            )
                          ])
                        ])
                      }),
                      0
                    )
                  ])
                : _c(
                    "div",
                    { staticClass: "loading_wrapper" },
                    [
                      _c("loading", {
                        staticClass: "loading ex-center-loading",
                        attrs: { loadingType: "dot" }
                      })
                    ],
                    1
                  ),
              _vm.addressList && _vm.addressList.length
                ? _c("div", { staticClass: "hw_btn_wrapper" }, [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: this.startIndex - this.addrNum > 0,
                            expression: "(this.startIndex - this.addrNum) > 0"
                          }
                        ],
                        staticClass: "code_small_btn",
                        on: {
                          click: function($event) {
                            return _vm.getAddressList("pre")
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("assets.ledger.addressSelect.prePage"))
                        )
                      ]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "code_small_btn",
                        on: {
                          click: function($event) {
                            return _vm.getAddressList("next")
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("assets.ledger.addressSelect.nextPage"))
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm.addressList && _vm.addressList.length
                ? _c("div", { staticClass: "__row btn_wrapper" }, [
                    _c(
                      "div",
                      {
                        staticClass: "btn btn-blue __pointer",
                        class: { "btn-gray": _vm.isBtnUnuse },
                        on: {
                          click: function($event) {
                            return _vm.confirm()
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("assets.ledger.addressSelect.confirm"))
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ])
          : _c(
              "div",
              { staticClass: "__row" },
              [
                _c("div", { staticClass: "ledger_introduction" }, [
                  _c("span", { staticClass: "ledger_introduction__header" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("assets.ledger.connect.introduction.1.title")
                      )
                    )
                  ]),
                  _c("span", { staticClass: "ledger_introduction__content" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("assets.ledger.connect.introduction.1.content")
                      )
                    )
                  ])
                ]),
                _c("lottie", {
                  staticClass: "ledger_lottie",
                  attrs: { type: "plugAndPinCode" }
                }),
                _c("div", { staticClass: "ledger_introduction" }, [
                  _c("span", { staticClass: "ledger_introduction__header" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("assets.ledger.connect.introduction.2.title")
                      )
                    )
                  ]),
                  _c("span", { staticClass: "ledger_introduction__content" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("assets.ledger.connect.introduction.2.content")
                      )
                    )
                  ])
                ]),
                _c("lottie", {
                  staticClass: "ledger_lottie",
                  attrs: { type: "openApp" }
                }),
                _c("div", { staticClass: "__row ledger_connect_btn" }, [
                  _c(
                    "div",
                    {
                      staticClass: "btn btn-blue __pointer",
                      on: {
                        click: function($event) {
                          return _vm.connect("usb")
                        }
                      }
                    },
                    [
                      _c("loading", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.connectPending,
                            expression: "connectPending"
                          }
                        ],
                        attrs: { loadingType: "dot" }
                      }),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.connectPending,
                              expression: "!connectPending"
                            }
                          ]
                        },
                        [_vm._v(_vm._s(_vm.$t("assets.ledger.connectWithUSB")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "btn btn-blue __pointer",
                      on: {
                        click: function($event) {
                          return _vm.connect("blu")
                        }
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.connectPending,
                              expression: "!connectPending"
                            }
                          ]
                        },
                        [_vm._v(_vm._s(_vm.$t("assets.ledger.connectWithBlu")))]
                      ),
                      _c("loading", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.connectPending,
                            expression: "connectPending"
                          }
                        ],
                        attrs: { loadingType: "dot" }
                      })
                    ],
                    1
                  )
                ])
              ],
              1
            )
      ]),
      _vm.ShowBottom
        ? _c("div", { style: _vm.s.btnGroup }, [
            !!_vm.STxt
              ? _c(
                  "div",
                  {
                    style: [
                      _vm.s.btn,
                      _vm.BtnUnuse || _vm.btnUnuse ? _vm.s.unUse : undefined
                    ],
                    on: { click: _vm.rClick }
                  },
                  [_vm._v(_vm._s(_vm.STxt))]
                )
              : _vm._e(),
            !_vm.STxt
              ? _c(
                  "div",
                  { style: [_vm.s.lBtn, _vm.s.btn], on: { click: _vm.lClick } },
                  [_vm._v(_vm._s(_vm.LTxt))]
                )
              : _vm._e(),
            !_vm.STxt
              ? _c(
                  "div",
                  {
                    style: [
                      _vm.s.btn,
                      _vm.BtnUnuse || _vm.btnUnuse ? _vm.s.unUse : undefined
                    ],
                    on: { click: _vm.rClick }
                  },
                  [_vm._v(_vm._s(_vm.RTxt))]
                )
              : _vm._e()
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }